import {
  useCurrentClientManager,
  useEntitiesThatCannotOnboardSubentities,
} from '@cko/dashboard-shared';
import { useQuery } from '@tanstack/react-query';

import settings from '../../../../services/app-settings';
import {
  useProcessingChannelsFetcher,
  UseProcessingChannelsQueryKey,
} from './useProcessingChannelsFetcher';
import { ProcessingChannel, ProcessingChannelsResponseBody } from './types';
import { filterProcessingChannels, mapResponseToProcessingChannels } from './selector';

export const useProcessingChannels = () => {
  const { client, entity } = useCurrentClientManager();
  const acceptedEntityIds = useEntitiesThatCannotOnboardSubentities();

  const queryKey: UseProcessingChannelsQueryKey = [
    `${settings.api.serverSideApiBasePath}/processing-channels`,
    {
      clientId: client.id,
      entityId: entity?.id,
    },
  ];

  return useQuery<
    ProcessingChannelsResponseBody,
    Error,
    ProcessingChannel[],
    UseProcessingChannelsQueryKey
  >(queryKey, useProcessingChannelsFetcher(), {
    select: (data) => {
      const processingChannels = mapResponseToProcessingChannels(data);
      const filteredProcessingChannels = filterProcessingChannels(
        processingChannels,
        acceptedEntityIds,
      );

      return filteredProcessingChannels;
    },
  });
};
